import Logo from "assets/STEPLogoIcon.png";

import "./style.scss";

const Navbar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  return (
    <div
      className="navbar-container"
      onClick={() => setIsSidebarOpen(!isSidebarOpen)}
    >
      <img className="navbar-logo" src={Logo} alt="logo" />
      <p className="navbar-text">Menu</p>
    </div>
  );
};

export default Navbar;
